query(
    $filter: MarketTemplateFilter
) {
  marketTemplates: allMarketTemplates(
    filter: $filter
) {
    nodes {
      marketTemplateId
      sportId
      sportLabel
      template
      sportLogicTemplates: sportLogicTemplatesByMarketTemplateId {
        nodes {
          sportLogicTemplateId
          name
          rulesSet
          defaultDisplayConfiguration
          defaultOfferingConfiguration
          defaultLimitConfiguration
          defaultMarginConfiguration
          defaultResultingConfiguration
          defaultTemplateConfiguration
        }
      }
    }
  }
}
